/* VAIRE Routine Finder: guided skincare consultation using the live Shopify catalogue. */
(function () {
  'use strict';
  const S = window.Store, UI = window.VaireUI;
  const $ = s => document.querySelector(s);
  const PROFILE_VERSION = 2;

  const QUESTIONS = [
    { key: 'primary', q: 'What do you most want help with?', help: 'Choose the change that would make the biggest difference to your routine.', opts: [
      ['comfort', 'Dryness or a stressed barrier', 'Tightness, flaking, or skin that feels less comfortable than it should.'],
      ['clarity', 'Oil, congestion, or visible pores', 'You want balance and a clearer-looking surface without stripping.'],
      ['glow', 'Dullness or uneven-looking tone', 'The complexion looks flat and you want a fresher, more even finish.'],
      ['smooth', 'Texture or early fine lines', 'You want a smoother-looking surface and a more refined finish.'],
      ['basics', 'I am not sure where to begin', 'Start with a calm, dependable routine and remove the guesswork.']
    ]},
    { key: 'secondary', q: 'Is there a second priority?', help: 'This keeps the routine useful without asking one product to do everything.', opts: [
      ['comfort', 'More comfort', 'Support moisture and keep the routine measured.'],
      ['clarity', 'More balance', 'Keep shine and visible congestion in mind.'],
      ['glow', 'More radiance', 'Favor products that leave skin looking fresh.'],
      ['smooth', 'A smoother finish', 'Keep visible texture in the edit.'],
      ['none', 'No, keep one clear focus', 'A shorter brief often makes a better starting routine.']
    ]},
    { key: 'skin', q: 'How does bare skin feel 30 minutes after cleansing?', help: 'Think about skin with nothing applied. This is more useful than how it feels immediately after washing.', opts: [
      ['dry', 'Tight, dry, or flaky', 'Comfort usually improves with a richer final layer.'],
      ['oily', 'Shiny across most of the face', 'A weightless gel texture is usually easier to live with.'],
      ['combo', 'Shiny through the T-zone, drier elsewhere', 'Different areas want a balanced middle weight.'],
      ['balanced', 'Comfortable, neither dry nor oily', 'Texture can follow your main goal.'],
      ['unsure', 'It changes, or I am not sure', 'We will choose a flexible, middle-weight routine.']
    ]},
    { key: 'reactivity', q: 'How often does new skincare feel uncomfortable?', help: 'Stinging, persistent redness, or a hot feeling are reasons to take a slower route.', opts: [
      ['high', 'Often', 'My skin is easily unsettled, even by products labeled gentle.'],
      ['some', 'Sometimes', 'I do best when I add one new product at a time.'],
      ['low', 'Rarely', 'My skin usually accepts a varied routine.'],
      ['unsure', 'I am not sure', 'Use the cautious route until you know more.']
    ]},
    { key: 'actives', q: 'How should we handle exfoliating actives?', help: 'More active is not automatically better. Consistency comes first.', opts: [
      ['avoid', 'Keep them out for now', 'I want a straightforward, low-friction starting point.'],
      ['gentle', 'Introduce one carefully', 'I am open to a measured treatment, used less often at first.'],
      ['experienced', 'I already use them comfortably', 'My skin is accustomed to a deliberate active step.'],
      ['unsure', 'I am not sure', 'Choose the cautious route and leave stronger actives out.']
    ]},
    { key: 'time', q: 'When will you actually use this routine?', help: 'We will only recommend steps that have a clear place in your day.', opts: [
      ['morning', 'Morning', 'A polished start with a final sun-protection step.'],
      ['evening', 'Evening', 'A reset that removes the day and restores comfort.'],
      ['both', 'Morning and evening', 'One edited wardrobe with a clear order for each time.']
    ]},
    { key: 'finish', q: 'What should the last morning step feel like?', help: 'If your routine is evening-only, choose the finish you would prefer when you add mornings later.', opts: [
      ['mineral', 'Sheer mineral tint', 'Light coverage and labeled mineral SPF in one final layer.'],
      ['makeup', 'Smooth under makeup', 'A color-correcting primer with labeled SPF.'],
      ['polished', 'Tinted and polished', 'A tone-adjusting CC finish with labeled SPF.'],
      ['flexible', 'No strong preference', 'Choose the most versatile everyday finish.']
    ]},
    { key: 'pace', q: 'How much routine will you truly keep using?', help: 'Choose for an ordinary busy week, not an ideal one.', opts: [
      ['essential', 'The essentials', 'No more than three steps at one time of day.'],
      ['core', 'A complete daily routine', 'Four clear steps feels realistic.'],
      ['ritual', 'Daily care plus a weekly ritual', 'I enjoy a fuller routine when every step has a reason.']
    ]}
  ];

  const CONCERNS = {
    comfort: 'barrier comfort', clarity: 'clarity and balance',
    glow: 'radiance and even-looking tone', smooth: 'a smoother-looking finish',
    basics: 'a dependable starting routine', none: 'one clear priority'
  };
  const PROFILES = {
    comfort: 'The Barrier First Edit', clarity: 'Clear, Never Stripped',
    glow: 'The Soft Radiance Edit', smooth: 'Smooth in Stages',
    basics: 'The Groundwork'
  };
  const LABELS = {
    skin: { dry: 'tight or dry after cleansing', oily: 'shiny after cleansing', combo: 'combination', balanced: 'balanced', unsure: 'changeable or uncertain' },
    reactivity: { high: 'frequently reactive', some: 'occasionally reactive', low: 'rarely reactive', unsure: 'sensitivity unknown' },
    actives: { avoid: 'no exfoliating actives', gentle: 'one measured active', experienced: 'active-experienced', unsure: 'cautious with actives' },
    time: { morning: 'morning', evening: 'evening', both: 'morning and evening' },
    pace: { essential: 'essentials only', core: 'complete daily routine', ritual: 'daily care plus a weekly ritual' }
  };

  const HANDLES = {
    cleanser: 'deep-cleansing-oil-for-face-makeup-remover-oil-cleanser-for-face-skincare-centella-cleansing-oils-non-comedogenic-makeup-blackhead-remover-pore-cleaner-facial-wash-for-sensitive-skin',
    heartleaf: 'heartleaf-85-calming-toner-for-face-85-heartleaf-extract-hydrating-korean-toner-jeju-houttuynia-cordata-extract-for-sensitive-skin-ph-balanced-korean',
    riceToner: 'hydrating-milky-toner-for-face-with-rice-ferment-niacinamide-collagen-korean-milk-skin-toner-essence-with-pdrn-hyaluronic-acid-ceramides-for-skin-barrier-repair-daily-am-pm-skincare',
    matchaPads: 'matcha-pdrn-korean-toner-pads-dark-spots-pores-redness-vegan-gentle-exfoliation-smoothing-hydrating-even-tone-am-pm-acne-prone-sensitive-skin-100ct',
    pdrn: 'pdrn-serum-rejuvenating-peptide-face-serum-with-salmon-dna-korean-skincare-for-anti-aging-hydration-collagen-boost-and-barrier-repair-brightening-daily-skincare-for-dark-spots-and-uneven-tone',
    pdrnUnscented: 'salmon-dna-pdrn-peptide-serum-stem-cell-serum-for-face-with-salmon-dna-korean-skin-care-for-sensitive-skin-deep-hydration-moisturizing-fast-absorbingunscented-1-01-fl-oz-30ml',
    pdrnPink: 'pdrn-pink-peptide-salmon-dna-serum-pink-glow-5-niacinamide-1fl-oz-pdrn-serum-with-niacinamide-peptides-for-rejuvenation-hydration-skin-barrier-support-smoothing-uneven-tone-korean-care',
    propolis: 'propolis-glazed-serum-honey-based-glow-serum-for-glass-skin-hydration-skin-barrier-care-lightweight-dual-layer-formula-niacinamide-korean-skin-care-1-01fl-oz',
    fiveCeramide: 'ceramide-moisturizer-five-ceramide-barrier-dry-face-cream',
    pdrnCream: 'skin-wrapping-cream-pdrn-ceramide-moisturizer-for-dewy-glass-skin-skin-barrier-hydration-non-comedogenic-tested-korean-skincare-1-69-fl-oz',
    pomegranate: 'face-moisturizer-brightening-facial-moisturizer-with-5-niacinamide-pomegranate-gel-cream-for-uneven-skin-tone-calming-allantoin-for-sensitive-skin-all-skin-types-100g',
    blueberry: 'blueberry-ceramide-face-moisturizer-barrier-cream-for-dry-sensitive-redness-prone-skin-strengthen-skin-barrier-calm-irritation-deep-hydration-5x-ceramides-blueberry-100g',
    yuja: 'brightening-face-moisturizer-facial-dark-spot-moisturizer-with-yuja-symwhite-377-hydrating-gel-cream-for-uneven-skin-tone-calming-panthenol-for-sensitive-skin-all-skin-types-100g',
    kiwi: 'oil-free-face-moisturizer-for-oily-skin-for-blemish-prone-skin-with-3d-complex-kiwi-extract-lightweight-hydrating-redness-calming-100g',
    mineralSpf: 'tinted-sunscreen-for-face-mineral-spf-30-moisturizer-light-1-7oz-skin-care-face-sunscreen-hyaluronic-acid-zinc-oxide-titanium-dioxide-sheer-tint-healthy-glow-blends-seamlessly',
    primerSpf: '3-in-1-primer-for-face-before-makeup-spf-50-sunscreen-isolation-cream-one-step-color-corrector-makeup-primer-oil-control-tinted-moisturizer-color-correcting-concealer-base-de-maquillaje-01',
    ccSpf: 'cc-cream-skin-tone-adjusting-for-mature-skin-complete-correction-super-active-light-moisturizer-spf-50-1-0-fl-oz-natural-30ml',
    riceMask: 'r4-rice-wash-off-facial-mask-4-in-1-korean-skin-care-pore-refining-gentle-exfoliating-hydrating-smooth-texture-rice-ferment-enzyme-soft-cream-wash-off-3-38-fl-oz',
    mugwortMask: 'mugwort-mask-wash-off-calming-face-mask-with-mugwort-extract-cooling-soothing-care-for-sensitive-skin-korean-skincare-2-46-fl-oz',
    honeyMask: 'honey-mask-deep-nourishing-wash-off-mask-with-natural-honey-glass-dewy-glow-long-lasting-hydration-korean-skin-care-2-37fl-oz',
    clayMask: 'blackhead-remover-clay-mask-stick-volcanic-mud-kaolin-1-58oz-charcoal-clay-mask-stick-for-deep-pore-detox-controls-oil-refines-pores-gentle-for-all-skin-types-compact-travel-size'
  };

  function savedProfile() {
    try {
      const value = JSON.parse(localStorage.getItem('vaire_profile') || 'null');
      return value && value.version === PROFILE_VERSION && value.answers &&
        QUESTIONS.every(q => value.answers[q.key]) ? value : null;
    } catch (e) { return null; }
  }
  function updateFinderLabels() {
    const saved = !!savedProfile();
    document.querySelectorAll('[data-quiz]').forEach(link => {
      if (link.dataset.quizContext === 'desktop') link.textContent = saved ? 'YOUR ROUTINE' : 'FINDER';
      if (link.dataset.quizContext === 'mobile') link.textContent = saved ? 'Your saved routine' : 'Routine finder';
    });
  }
  function productText(p) {
    return (p.name + ' ' + p.subcategory + ' ' + (p.tags || []).join(' ')).toLowerCase();
  }
  function skinEligible(p) {
    const t = productText(p);
    return p.available !== false && p.category === 'skin' &&
      !/\b(body|hair|lip|foot|neck|tool|roller|brush|device|cupping|stamp|micro)\b/.test(t);
  }
  function resolve(handle, wants, subcats) {
    const exact = handle && S.byId(handle);
    if (exact && exact.available !== false) return exact;
    const ranked = S.products.filter(skinEligible).map(p => {
      const t = productText(p);
      let score = (subcats || []).includes(p.subcategory) ? 10 : 0;
      (wants || []).forEach((word, index) => { if (t.includes(word)) score += Math.max(2, 14 - index * 2); });
      return { p, score };
    }).sort((a, b) => b.score - a.score);
    return (ranked.find(x => x.score > 0) || {}).p || null;
  }
  function optionsFor(q) {
    if (q.key !== 'secondary') return q.opts;
    return q.opts.filter(o => o[0] === 'none' || o[0] !== answers.primary);
  }
  function uniqueItems(items) {
    const seen = new Set();
    return items.filter(item => item && item.product && !seen.has(item.product.id) && seen.add(item.product.id));
  }

  function recommend(a) {
    const focus = a.primary === 'basics' && a.secondary !== 'none' ? a.secondary : a.primary;
    const cautious = a.reactivity === 'high' || a.reactivity === 'unsure' || a.actives === 'avoid' || a.actives === 'unsure';
    const cleanser = resolve(HANDLES.cleanser, ['centella', 'cleansing oil', 'cleanser'], ['cleanser']);
    let prep = null, prepActive = false;
    if (a.pace !== 'essential') {
      if (focus === 'clarity' && a.actives === 'experienced' && !cautious) {
        prep = resolve(null, ['triple-action exfoliating toner', 'exfoliating toner'], ['treatment']);
        prepActive = true;
      } else if (focus === 'clarity' && !cautious) {
        prep = resolve(HANDLES.matchaPads, ['matcha pdrn toner pads', 'toner pads'], ['treatment']);
      } else if (a.skin === 'dry' || focus === 'glow') {
        prep = resolve(HANDLES.riceToner, ['rice ferment milky toner', 'milky toner'], ['treatment']);
      } else {
        prep = resolve(HANDLES.heartleaf, ['heartleaf 85 calming toner', 'heartleaf toner'], ['treatment']);
      }
    }

    let treatment = null;
    if (!(a.primary === 'basics' && a.pace === 'essential')) {
      if (cautious || focus === 'comfort') treatment = resolve(HANDLES.pdrnUnscented, ['unscented pdrn peptide serum', 'pdrn peptide serum'], ['serum']);
      else if (focus === 'glow') treatment = resolve(HANDLES.propolis, ['propolis glazed', 'glow serum'], ['serum']);
      else if (focus === 'clarity') treatment = resolve(HANDLES.pdrnPink, ['pink pdrn peptide serum', 'niacinamide serum'], ['serum']);
      else treatment = resolve(HANDLES.pdrn, ['pdrn peptide renewal serum', 'peptide serum'], ['serum']);
    }

    let moisturizer;
    if (a.reactivity === 'high') moisturizer = resolve(HANDLES.blueberry, ['blueberry five-ceramide', 'barrier cream'], ['moisturizer']);
    else if (a.skin === 'dry') moisturizer = resolve(focus === 'glow' ? HANDLES.pdrnCream : HANDLES.fiveCeramide, ['ceramide', 'barrier moisturizer'], ['moisturizer']);
    else if (a.skin === 'oily') moisturizer = resolve(HANDLES.kiwi, ['kiwi oil-free hydration gel cream', 'oil-free gel cream'], ['moisturizer']);
    else if (focus === 'glow') moisturizer = resolve(HANDLES.yuja, ['yuja 377 radiance gel cream', 'radiance gel cream'], ['moisturizer']);
    else moisturizer = resolve(HANDLES.pomegranate, ['pomegranate 5% niacinamide gel cream', 'gel cream'], ['moisturizer']);

    const spfHandles = { mineral: HANDLES.mineralSpf, makeup: HANDLES.primerSpf, polished: HANDLES.ccSpf, flexible: HANDLES.mineralSpf };
    const spfWords = a.finish === 'makeup' ? ['spf 50 color-correcting makeup primer'] : a.finish === 'polished' ? ['spf 50 tone-adjusting cc cream'] : ['mineral spf 30 tinted moisturizer', 'tinted sunscreen'];
    const protect = a.time === 'evening' ? null : resolve(spfHandles[a.finish], spfWords, ['spf']);

    let weekly = null;
    if (a.pace === 'ritual') {
      if (cautious) weekly = resolve(HANDLES.mugwortMask, ['mugwort cooling wash-off mask'], ['mask']);
      else if (focus === 'comfort') weekly = resolve(HANDLES.honeyMask, ['honey dew wash-off mask'], ['mask']);
      else if (focus === 'clarity' && !prepActive) weekly = resolve(HANDLES.clayMask, ['volcanic clay mask stick', 'clay mask'], ['mask']);
      else if (prepActive) weekly = resolve(HANDLES.mugwortMask, ['mugwort cooling wash-off mask'], ['mask']);
      else weekly = resolve(HANDLES.riceMask, ['rice ferment wash-off mask'], ['mask']);
    }

    const items = uniqueItems([
      { role: 'CLEANSE', product: cleanser, timing: a.time === 'both' ? 'AM / PM' : a.time.toUpperCase(), why: 'Removes sunscreen, makeup, and daily buildup so the rest of the routine starts on clean skin.', use: 'Massage onto dry skin, add water to emulsify, then rinse as directed on the label.' },
      prep && { role: prepActive ? 'RENEW' : 'PREP', product: prep, timing: prepActive ? 'PM / 2 NIGHTS WEEKLY TO START' : (a.time === 'both' ? 'AM / PM' : a.time.toUpperCase()), why: prepActive ? 'Adds one controlled exfoliating step for visible congestion and uneven texture.' : cautious ? 'Adds a light first layer while keeping the routine measured.' : `Prepares the routine around ${CONCERNS[focus]}.`, use: prepActive ? 'Use on separate nights from other exfoliating products. Increase only if skin stays comfortable.' : 'Apply after cleansing and before serum, following the amount on the label.' },
      treatment && { role: 'TARGET', product: treatment, timing: a.time === 'morning' ? 'AM' : a.time === 'evening' ? 'PM' : 'AM / PM', why: cautious ? 'A fragrance-free, lower-friction serum choice for a careful start.' : `The focused daily step for ${CONCERNS[focus]}.`, use: 'Apply after toner and before moisturizer. Begin once daily when the formula is new to you.' },
      { role: 'SEAL', product: moisturizer, timing: a.time === 'both' ? 'AM / PM' : a.time.toUpperCase(), why: a.skin === 'oily' ? 'A lighter gel texture gives moisture without adding a dense final layer.' : a.skin === 'dry' ? 'A more cushioned cream helps answer tightness and visible dryness.' : 'A balanced final layer chosen for the way your skin behaves after cleansing.', use: 'Smooth over face and neck after lighter layers.' },
      protect && { role: 'PROTECT', product: protect, timing: 'AM / FINAL STEP', why: 'Completes the morning routine with the labeled sun-protection and finish you selected.', use: 'Apply as directed on the label as the last morning step, and reapply as directed.' },
      weekly && { role: 'WEEKLY', product: weekly, timing: 'PM / ONCE WEEKLY TO START', why: cautious ? 'A cooling wash-off pause that keeps the optional step calm.' : `An optional ritual selected around ${CONCERNS[focus]}.`, use: 'Use on a quiet evening and follow the label. Skip it whenever skin feels uncomfortable.' }
    ]);

    const essentialItems = items.filter(item => {
      if (item.role === 'WEEKLY' || item.role === 'PREP' || item.role === 'RENEW') return a.pace !== 'essential';
      if (a.pace === 'essential' && a.time === 'morning' && item.role === 'TARGET') return false;
      return true;
    });
    const routines = [];
    if (a.time !== 'evening') {
      const am = [
        ['01', 'CLEANSE OR RINSE', 'Use the cleanser when you need to remove overnight product; a water rinse may be enough when skin feels dry.'],
        ...(a.pace !== 'essential' && prep && !prepActive ? [['02', 'PREP', prep.name]] : []),
        ...(a.pace !== 'essential' && treatment ? [['03', 'TARGET', treatment.name]] : []),
        ['04', 'MOISTURIZE', moisturizer.name],
        ['05', 'PROTECT', protect ? protect.name : 'Use a broad-spectrum sunscreen that suits you.']
      ];
      routines.push({ label: 'MORNING', lines: am });
    }
    if (a.time !== 'morning') {
      const pm = [
        ['01', 'CLEANSE', cleanser ? cleanser.name : 'Cleanse thoroughly'],
        ...(a.pace !== 'essential' && prep ? [['02', prepActive ? 'RENEW / START TWICE WEEKLY' : 'PREP', prep.name]] : []),
        ...(treatment ? [['03', 'TARGET', treatment.name]] : []),
        ['04', 'MOISTURIZE', moisturizer.name]
      ];
      routines.push({ label: 'EVENING', lines: pm });
    }
    return { items: essentialItems, routines, cautious, focus, prepActive };
  }

  function html() {
    return `<div class="quizov" id="quizov" role="dialog" aria-modal="true" aria-label="Vaire routine finder">
      <button class="close mono" id="quizClose" aria-label="Close routine finder">CLOSE &#10005;</button>
      <div class="inner" id="quizInner"></div>
    </div>`;
  }

  let step = -1, answers = {};
  function scrollTop() {
    const ov = $('#quizov');
    if (ov) ov.scrollTo({ top: 0, behavior: 'smooth' });
  }
  function focusFirst() {
    requestAnimationFrame(() => {
      const target = $('#quizInner button:not([disabled])');
      if (target) target.focus({ preventScroll: true });
    });
  }
  function renderIntro(el) {
    el.innerHTML = `<div class="qintro">
      <div class="mono qstep">THE VAIRE CONSULTATION</div>
      <h2 class="qq">Build a routine you will understand and keep.</h2>
      <p class="qintro-copy">Eight practical questions help us choose the right product weight, routine length, treatment pace, and morning finish from the live Vaire skincare edit.</p>
      <div class="qintro-points">
        <div><b>ABOUT 2 MINUTES</b><span>No email gate. Your answers stay in this browser.</span></div>
        <div><b>NO GUESSING REQUIRED</b><span>Every answer includes a plain-language example.</span></div>
        <div><b>A ROUTINE, NOT A PILE</b><span>Your result explains order, timing, and why each step earned its place.</span></div>
      </div>
      <button class="btn champagne qstart" id="qStart">BEGIN THE CONSULTATION<span class="flash"></span></button>
      <p class="qdisclaimer">This finder offers cosmetic routine guidance, not a diagnosis or medical treatment.</p>
    </div>`;
    $('#qStart').addEventListener('click', () => { step = 0; render(); scrollTop(); });
  }
  function renderQuestion(el) {
    const q = QUESTIONS[step], opts = optionsFor(q), selected = answers[q.key];
    const pct = Math.round((step / QUESTIONS.length) * 100);
    el.innerHTML = `<div class="qprogress" aria-hidden="true"><i style="width:${pct}%"></i></div>
      <div class="mono qstep">${String(step + 1).padStart(2, '0')} / ${String(QUESTIONS.length).padStart(2, '0')} &middot; THE ROUTINE FINDER</div>
      <h2 class="qq">${q.q}</h2>
      <p class="qhelp">${q.help}</p>
      <div class="qopts">${opts.map(o => `<button class="qopt ${selected === o[0] ? 'selected' : ''}" data-v="${o[0]}" aria-pressed="${selected === o[0]}"><span>${o[1]}</span><small>${o[2]}</small></button>`).join('')}</div>
      <div class="qnav"><button class="mono qback" id="qBack">&larr; BACK</button><button class="btn qcontinue" id="qContinue" ${selected ? '' : 'disabled'}>CONTINUE</button></div>`;
    el.querySelectorAll('.qopt').forEach(button => button.addEventListener('click', () => {
      answers[q.key] = button.dataset.v;
      if (q.key === 'primary' && answers.secondary === answers.primary) delete answers.secondary;
      el.querySelectorAll('.qopt').forEach(x => { const on = x === button; x.classList.toggle('selected', on); x.setAttribute('aria-pressed', String(on)); });
      $('#qContinue').disabled = false;
    }));
    $('#qContinue').addEventListener('click', () => { if (!answers[q.key]) return; step++; render(); scrollTop(); });
    $('#qBack').addEventListener('click', () => { step--; render(); scrollTop(); });
  }
  function renderResults(el) {
    const result = recommend(answers), profile = PROFILES[answers.primary];
    const secondary = answers.secondary !== 'none' ? `, with ${CONCERNS[answers.secondary]} kept in view` : '';
    try { localStorage.setItem('vaire_profile', JSON.stringify({ version: PROFILE_VERSION, answers, ids: result.items.map(x => x.product.id), at: Date.now() })); } catch (e) { }
    updateFinderLabels();
    const total = result.items.reduce((sum, item) => sum + S.price(item.product, item.product.shades ? 0 : null), 0);
    el.innerHTML = `<div class="qprogress done" aria-hidden="true"><i></i></div>
      <div class="mono qstep">YOUR VAIRE ROUTINE</div>
      <h2 class="qq qtitle">${profile}</h2>
      <p class="qsummary">Built around ${CONCERNS[answers.primary]}${secondary}, for skin that feels ${LABELS.skin[answers.skin]}.</p>
      <div class="qheard" aria-label="Your consultation answers">
        <span>${LABELS.skin[answers.skin]}</span><span>${LABELS.reactivity[answers.reactivity]}</span><span>${LABELS.actives[answers.actives]}</span><span>${LABELS.time[answers.time]}</span><span>${LABELS.pace[answers.pace]}</span>
      </div>
      <div class="qroutines">${result.routines.map(routine => `<section class="qroutine"><div class="mono">${routine.label}</div>${routine.lines.map(line => `<div class="qroutine-line"><b>${line[0]}</b><span><strong>${line[1]}</strong><small>${line[2]}</small></span></div>`).join('')}</section>`).join('')}</div>
      <div class="qresult-head"><div><span class="mono">THE PRODUCT EDIT</span><h3>${result.items.length} pieces, each with a job.</h3></div><p>Start with the core steps. Add the treatment and weekly piece only after the basics feel comfortable.</p></div>
      <div class="qresult-grid">${result.items.map((item, i) => `<div class="qresult">
        <div class="qresult-copy"><b>${String(i + 1).padStart(2, '0')} / ${item.role}</b><em>${item.timing}</em><p>${item.why}</p><small>${item.use}</small></div>
        ${UI.cardHTML(item.product)}
      </div>`).join('')}</div>
      <div class="qcare"><b>HOW TO BEGIN</b><p>Patch test first. Introduce one new formula at a time and give it several uses before adding the next. Stop if something feels uncomfortable. Persistent or sudden skin changes belong with a qualified clinician, not a product quiz.</p></div>
      <div class="qrow">
        <button class="btn champagne" id="qAddAll">ADD THE ROUTINE &middot; ${S.money(total)}<span class="flash"></span></button>
        <button class="mono qback" id="qAgain">RETAKE</button>
      </div>`;
    $('#qAddAll').addEventListener('click', async () => {
      const btn = $('#qAddAll');
      btn.disabled = true;
      try {
        for (const item of result.items) await S.cart.add(item.product.id, item.product.shades ? 0 : null);
        UI.flashbulb(btn); UI.springBadge(); close(); setTimeout(UI.openBag, 250);
      } catch (err) { btn.disabled = false; btn.textContent = 'TRY AGAIN'; }
    });
    $('#qAgain').addEventListener('click', () => {
      try { localStorage.removeItem('vaire_profile'); } catch (e) { }
      step = -1; answers = {}; updateFinderLabels(); render(); scrollTop();
    });
  }
  function render() {
    const el = $('#quizInner');
    if (step < 0) renderIntro(el);
    else if (step < QUESTIONS.length) renderQuestion(el);
    else renderResults(el);
    focusFirst();
  }

  function open() {
    const saved = savedProfile();
    step = saved ? QUESTIONS.length : -1;
    answers = saved ? saved.answers : {};
    render();
    $('#quizov').classList.add('open');
    document.body.style.overflow = 'hidden';
    scrollTop();
  }
  function close() { $('#quizov').classList.remove('open'); document.body.style.overflow = ''; }

  document.body.insertAdjacentHTML('beforeend', html());
  $('#quizClose').addEventListener('click', close);
  document.addEventListener('keydown', event => { if (event.key === 'Escape') close(); });
  document.addEventListener('click', event => { const target = event.target.closest('[data-quiz]'); if (target) { event.preventDefault(); open(); } });

  function addNavLink() {
    const desktop = document.querySelector('#vnav .links');
    if (desktop && !desktop.querySelector('[data-quiz]')) desktop.insertAdjacentHTML('beforeend', '<a href="#" data-quiz data-quiz-context="desktop">FINDER</a>');
    const mobile = document.querySelector('#mobileMenu');
    if (mobile && !mobile.querySelector('[data-quiz]')) mobile.insertAdjacentHTML('beforeend', '<a href="#" data-quiz data-quiz-context="mobile">Routine finder</a>');
    updateFinderLabels();
  }
  addNavLink();
  document.addEventListener('DOMContentLoaded', addNavLink);
  window.VaireQuiz = { open };
})();

